import axios from 'axios';
import { locale } from 'common/utils/helpers';

export const getCategories = search =>
  axios.get(`/meta/faq/category/list/bo/`, {
    params: search,
    headers: {
      locale,
    },
  });

export const getQuestions = id =>
  axios.get(`/meta/faq/category/${id}/`, {
    headers: {
      locale,
    },
  });
